import changeCart from './changeCart';
import getLocalePrefix from './getLocalePrefix';
import { initSwiper } from '../components/swiper';

const MINICART_LINE_ITEM_SELECTOR = '[data-minicart-line-item]';

const getMinicartData = async () => {
  const localePrefix = getLocalePrefix();
  const url = `${window.location.origin}${localePrefix}/cart?view=minicart`;
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    return await res.text();
  } catch (e) {
    console.error('Failed to fetch minicart:', e);
    return null;
  }
};

const setLineItemLoadingState = (lineItemEl) => {
  lineItemEl?.classList.add('opacity-50', 'pointer-events-none');
};

const stepLineQuantity = async (buttonEl, delta, renderMinicartFn) => {
  const stepperEl = buttonEl.closest('[data-minicart-stepper]');
  const valueEl = stepperEl?.querySelector('[data-minicart-qty-value]');
  if (!valueEl) return;

  const newQty = parseInt(valueEl.textContent, 10) + delta;
  if (Number.isNaN(newQty) || newQty < 1) return;

  setLineItemLoadingState(buttonEl.closest(MINICART_LINE_ITEM_SELECTOR));
  await changeCart(stepperEl.dataset.minicartStepper, newQty);
  await renderMinicartFn();
};

const removeLineItem = async (buttonEl, renderMinicartFn) => {
  setLineItemLoadingState(buttonEl.closest(MINICART_LINE_ITEM_SELECTOR));
  await changeCart(buttonEl.dataset.minicartRemoveItem, 0);
  await renderMinicartFn();
};

const bindMinicartEvents = (renderMinicartFn) => {
  const minicartEl = document.querySelector('[data-minicart]');
  if (!minicartEl) return;

  if (minicartEl.dataset.eventsBound === 'true') return;
  minicartEl.dataset.eventsBound = 'true';

  minicartEl.addEventListener('click', async (evt) => {
    const removeEl = evt.target.closest('[data-minicart-remove-item]');
    if (removeEl) {
      await removeLineItem(removeEl, renderMinicartFn);
      return;
    }

    const decreaseEl = evt.target.closest('[data-minicart-qty-decrease]');
    if (decreaseEl) {
      await stepLineQuantity(decreaseEl, -1, renderMinicartFn);
      return;
    }

    const increaseEl = evt.target.closest('[data-minicart-qty-increase]');
    if (increaseEl) {
      await stepLineQuantity(increaseEl, 1, renderMinicartFn);
    }
  });
};

const renderMinicartUpsell = async () => {
  const upsellContainerEl = document.querySelector('[data-minicart-upsell]');
  const upsellUrl = upsellContainerEl?.dataset.url;
  if (!upsellUrl) return;

  try {
    const response = await fetch(upsellUrl);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    upsellContainerEl.innerHTML = await response.text();

    const sliderEl = upsellContainerEl.querySelector('[data-swiper]');
    if (sliderEl) initSwiper(sliderEl);

    if (typeof window.ReloadSmartWishlist === 'function') {
      await window.ReloadSmartWishlist();
    }
  } catch (e) {
    console.error('Failed to fetch minicart upsell products:', e);
  }
};

const renderMinicart = async () => {
  const minicartContentEl = document.querySelector('[data-minicart-content]');
  if (!minicartContentEl) return;

  const htmlText = await getMinicartData();
  if (!htmlText) return;

  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlText, 'text/html');
  const minicartNewDataEl = doc.querySelector('[data-minicart-render]');
  if (!minicartNewDataEl) return;

  minicartContentEl.innerHTML = minicartNewDataEl.innerHTML;

  bindMinicartEvents(renderMinicart);
  renderMinicartUpsell();
};

export default renderMinicart;
